import { connect } from 'react-redux'
import { UpdateMediaTypeGroupForm as Component } from './UpdateMediaTypeGroupForm'

export const UpdateMediaTypeGroupForm = connect()(Component)
